import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const BookmarkIcon = ({
  width = 16,
  height = 16,
  stroke = '#4c5956',
  fill = 'none',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 16 16"
  >
    <path
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.375 13.625L8 10.5l-4.375 3.125v-10c0-.332.132-.65.366-.884.235-.234.552-.366.884-.366h6.25c.332 0 .65.132.884.366.234.235.366.552.366.884v10z"
    />
  </svg>
);
